export interface LogMessage {
    level: LogLevel;
    time?: string;
    data: LogBody;
}

export type LogBody = {
	message: string;
} & any;

export interface Logger {
	log(body: LogMessage): void;
	error(message: string | LogBody | Error): void;
	info(message: string | LogBody): void;
	warn(message: string | LogBody | Error): void;
}

export enum LogLevel {
    ERROR = 'ERROR',
    WARN = 'WARN',
    INFO = 'INFO',
}
